module.exports = __webpack_public_path__ + "img/p2000.6f9c4d6d.png";